import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-carousel-educacional-level',
  templateUrl: './carousel-educacional-level.component.html',
  styleUrls: ['./carousel-educacional-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselEducacionalLevelComponent {
  @Input() public levels: any[] = [];
}
